// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"19bfd289","579":"19bfd289","991":"19bfd289"}[chunkId] + ".chunk.css";
};